// Code-action: "Add missing table to FROM" — In-scope enumeration.
//
// Split out of addMissingTableToFrom.ts (behavior-neutral).

import type { QueryStructure } from '../../../sql-resolver/types/queryStructure';
import { defaultSchemaForEngine } from '../../go-to/externalNavigation';
import type { CodeActionContext } from '../../types';
import type { ScopeRelation } from './addMissingTableToFrom.types';

export function collectInScopeRelations(
  structure: QueryStructure,
  engineId: CodeActionContext['engineId'],
): readonly ScopeRelation[] {
  const out: ScopeRelation[] = [];
  const defaultSchema = defaultSchemaForEngine(engineId);
  for (const fi of structure.fromItems ?? []) pushRelation(out, fi, defaultSchema);
  for (const j of structure.joins ?? []) pushRelation(out, j.right, defaultSchema);
  return out;
}

function pushRelation(
  out: ScopeRelation[],
  fi: { target: { kind: string; qualified?: { name: string; schema?: string } }; alias?: { alias: string } },
  defaultSchema: string,
): void {
  if (fi.target.kind !== 'relation' || !fi.target.qualified) return;
  const userTypedSchema = fi.target.qualified.schema?.toLowerCase();
  out.push({
    name: fi.target.qualified.name,
    schema: (fi.target.qualified.schema ?? defaultSchema).toLowerCase(),
    ...(userTypedSchema ? { userTypedSchema } : {}),
    displayRef: fi.alias?.alias ?? fi.target.qualified.name,
  });
}

export function isInScope(name: string, schema: string, inScope: readonly ScopeRelation[]): boolean {
  return inScope.some(
    (r) => r.name.toLowerCase() === name.toLowerCase() && r.schema.toLowerCase() === schema.toLowerCase(),
  );
}
